import { Component, OnInit, Inject } from '@angular/core';
import { Dictionary } from 'models';
import { Page } from '_interfaces/page';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role } from 'enums';

export interface MilestoneTypeEditArgs {
  milestone: Dictionary;
}

@Component({
  selector: 'milestone-type-edit-dialog',
  templateUrl: './milestone-type-edit-dialog.component.html',
  styleUrls: ['./milestone-type-edit-dialog.component.scss'],
  standalone: false
})
export class MilestoneEditDialogComponent implements OnInit, Page {
  // page
  pageTitle = 'Edit milestone';
  pageDescription = 'edit data below to update milestone';

  // other properties
  milestone: Dictionary;
  isValid = false;
  Role = Role;

  constructor(
    public dialogRef: MatDialogRef<MilestoneEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MilestoneTypeEditArgs) {
  }

  ngOnInit() {
    this.milestone = {
      ...this.data.milestone
    };
  }

  onSaveClick(): void {
    if (this.isValid) {
      this.dialogRef.close(this.milestone);
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  isValidChanged(isValid: boolean) {
    this.isValid = isValid;
  }
}
